<template>
  <a-modal
    :title="name"
    :width="500"
    :footer="null"
    @cancel="handleCancel"
    :visible="visible"
    :confirmLoading="confirmLoading"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-row :gutter="24">
          <img  :src="formData.wxacode"  style="width: 100%" />
          <a-col align="center" v-if="mode != 'view'" :md="24" :sm="24">
            <!--<a-button @click="download" type="primary">下载二维码</a-button>-->
            <a-button @click="handleCancel" style="margin-left: 10px">取消</a-button>
          </a-col>
        </a-row>
      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>

  import fieldRule from '@/utils/field-validate-rules'
  import { postAxios, getAxios } from '@/api/request'
  const formList = {
    wxacode: '',
  }
  export default {
    name: 'shopAdd',
    data () {
      return {
        // 验证组件
//        fieldRule,
        shopName: '',
        name: '',
        mode: '',
        formData: { ...formList },
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 }
        },
        visible: false,
        confirmLoading: false,
        form: this.$form.createForm(this) // 注册后，才能通过表单拉取数据
      }
    },
    methods: {
      showImgs (record) {
        this.mode = 'edit'
        this.visible = true
        if (record) {
          this.formData = record
          this.shopName = record.name
          this.name = record.name
        }
      },
      download() {
        this.downloadIamge(this.formData.wxacode, 'pic')
      },

      downloadIamge(imgsrc, name) {//下载图片地址和图片名
        var image = new Image();
        // 解决跨域 Canvas 污染问题
        image.setAttribute("crossOrigin", "anonymous");
        image.onload = function() {
          var canvas = document.createElement("canvas");
          canvas.width = image.width;
          canvas.height = image.height;
          var context = canvas.getContext("2d");
          context.drawImage(image, 0, 0, image.width, image.height);
          var url = canvas.toDataURL("image/png"); //得到图片的base64编码数据

          var a = document.createElement("a"); // 生成一个a元素
          var event = new MouseEvent("click"); // 创建一个单击事件
          a.download = name || "photo"; // 设置图片名称
          a.href = url; // 将生成的URL设置为a.href属性
          a.h
          a.dispatchEvent(event); // 触发a的单击事件
        };
        image.src = imgsrc;
      },
      handleCancel () {
        this.visible = false
        this.confirmLoading = false
        this.form.resetFields() // 清空表单
        this.formData = { ...formList }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/view/shop/modules/showImg.vue